export default __webpack_public_path__ + "static/media/I Can Cook Anything.0b05f245.png";